import React from 'react'
import { useLocation, useRouteMatch } from 'react-router-dom'
import { PageTrail } from '../../sso-workspace/page-trail'
import { NoAccess } from '../../../role/components/no-access'
import { useAuditCapabilities } from '../use-audit-capabilities'
import { AuditEntryRoute } from '../entry-route'
import { AuditLogPage } from './audit-log-page'
import { SECTION } from '../../navigation/sections'

// /org/audit-log and /admin/audit-log: the Audit log, with an entry's
// permalink (…/entry/:entryID) opening its drawer over the list. The list
// is gated on /capabilities (the organization's on either audit log, the
// super admin's on sysAuditLog); nothing shows while they load. The drawer
// is not gated (AuditEntryRoute: the API decides), so a reader without the
// list who opens a copied link sees just the entry.
export const AuditLogRoute = ({ base, sys = false, home }) => {
  const caps = useAuditCapabilities()
  const onEntry = Boolean(useRouteMatch(`${base}/entry/:entryID`))
  const allowed = Boolean(caps.loaded && (sys ? caps.sysAuditLog : caps.canAudit))
  const section = sys ? SECTION.staffAuditLog : SECTION.auditLog
  // The crumb is the list, with its query, also while an entry is open in
  // its drawer (…/entry/:entryID), so it closes the drawer; it used to be the
  // entry's own address, and did nothing (audit F17).
  const { search } = useLocation()
  const listCrumb = { ...section, url: `${base}${search}` }

  return (
    <React.Fragment>
      {allowed &&
        <React.Fragment>
          <PageTrail trail={[listCrumb]} />
          <AuditLogPage sys={sys} caps={caps} />
        </React.Fragment>}
      {caps.loaded && !allowed && !onEntry && <NoAccess what="the audit log" />}
      <AuditEntryRoute base={base} sys={sys} home={home} listAllowed={allowed} />
    </React.Fragment>
  )
}
